import { AnchorClientRoutes } from '../AnchorClientRoutes';
import { getIsOnePublished } from '../Episode';
import * as ServerRenderingUtils from '../../../helpers/serverRenderingUtils.js';
import { Episode, ImportedPodcast, Podcast } from '../../types';

const getIsMinimallySetup = (podcast: Podcast): boolean =>
  Boolean(podcast.name && podcast.description && podcast.iTunesCategory);

const getIsAutoPairable = (podcast: Podcast): boolean => podcast.isAutoPairable;

const getIsAnImportedPodcast = (podcast: Podcast): boolean =>
  podcast.kind === 'importedPodcast';

// TODO: we should also determine this status by looking at the local session store tutrial.dismissedBanners[BANNER_STATES.NO_STATUS]
const getWasDistributionActionTaken = (podcast: Podcast): boolean =>
  podcast.distributionRequestStatus !== 'noActionTaken';

// TODO: we should also determine this status by looking at the local session store tutrial.dismissedBanners[BANNER_STATES.NO_STATUS]
const getIsDistributed = (podcast: Podcast): boolean =>
  ['active', 'pending'].includes(podcast.distributionRequestStatus);

const getIsRedirectionComplete = (podcast: ImportedPodcast): boolean =>
  podcast.redirectStatus === 'redirected' ||
  podcast.redirectStatus === 'ignored';

// Was sponsorships action taken?
const getHasSponsorshipsBeenActivatedOrDeactived = (
  podcast: Podcast
): boolean =>
  podcast.sponsorshipsActivationStatus === 'activated' ||
  podcast.sponsorshipsActivationStatus === 'deactivated';
const getIsMonetizationSetup = (
  podcast: Podcast,
  isPaywallsSetup: boolean
): boolean =>
  Boolean(
    podcast.sponsorshipsActivationStatus === 'activated' ||
      podcast.hasSupportersEnabled ||
      isPaywallsSetup
  );

const getIsSponsorshipsActivated = (sponsorshipsActivationStatus: string) =>
  sponsorshipsActivationStatus === 'activated';

const getCurrentlyAvailablePlatformsCount = (
  podcast: Podcast,
  episodes: Episode[]
): number =>
  getIsOnePublished(episodes) ? podcast.listeningPlatforms.length : 0;

const getHasCreatedAnEpisode = (podcast: Podcast): boolean =>
  podcast.episodeIds.length > 0;

const getHTMLEmbedCode = (podcast: Podcast): string => {
  const embedUrl = `${ServerRenderingUtils.getBaseUrl()}${AnchorClientRoutes.getUrlPathForPodcastEmbed(
    podcast
  )}`;
  return `<iframe src="${embedUrl}" height="102px" width="400px" frameborder="0" scrolling="no"></iframe>`;
};

const getFacebookShareUrl = (podcast: Podcast): string => {
  const podcastPublicUrl = `${ServerRenderingUtils.getBaseUrl()}${AnchorClientRoutes.getUrlPathForPodcastPublicProfile(
    podcast
  )}`;
  return `https://www.facebook.com/dialog/share?app_id=446611785530020&href=${podcastPublicUrl}&redirect_uri=${podcastPublicUrl}`;
};

const getName = (podcast: Podcast): string =>
  podcast.name ? podcast.name : 'Untitled';

const getTwitterShareUrl = (podcast: Podcast) => {
  const podcastPublicUrl = `${ServerRenderingUtils.getBaseUrl()}${AnchorClientRoutes.getUrlPathForPodcastPublicProfile(
    podcast
  )}`;
  const shareText = `Listen to ${getName(podcast)} on ⚓`;
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    shareText
  )} ${podcastPublicUrl}`;
};

const getCoverartUrl = (
  podcast: Podcast,
  size: 'normalSize' | 'fullSize'
): string | null => {
  switch (size) {
    case 'normalSize':
      return podcast.coverartImage && podcast.coverartImage.normalSize
        ? podcast.coverartImage.normalSize.url
        : null;
    case 'fullSize':
      return podcast.coverartImage && podcast.coverartImage.fullSize
        ? podcast.coverartImage.fullSize.url
        : null;
  }
};

export {
  getIsRedirectionComplete,
  getIsMinimallySetup,
  getHasCreatedAnEpisode,
  getIsAnImportedPodcast,
  getIsMonetizationSetup,
  getWasDistributionActionTaken,
  getIsDistributed,
  getHTMLEmbedCode,
  getFacebookShareUrl,
  getName,
  getTwitterShareUrl,
  getCoverartUrl,
  getCurrentlyAvailablePlatformsCount,
  getHasSponsorshipsBeenActivatedOrDeactived,
  getIsSponsorshipsActivated,
  getIsAutoPairable,
};
